import React from 'react';
import './AgendaPage.css';



const CongressionalSchedule = ({ webpageData }) => {

    const agendaData = webpageData?.agendaSection || {};

    return (
        <div className="cschedule-wrapper">
            <div className="cschedule-container">
                <div className="cschedule-header">
                    <p className="cschedule-subheading">CONFIRMED AGENDA</p>
                    <h2 className="cschedule-title">The First Annual<br />Congressional Exchange</h2>
                </div>
                <div className="cschedule-timeline">
                    {webpageData?.agendaSection?.items?.map((item, index) => {
                        const isHalfBlock = [0, 1, 5, 6].includes(index);
                        const blockColor = item.color === 'lavender' ? 'cschedule-border-lavender' : 'cschedule-border-green';

                        let customWidthClass = '';
                        // if (index === 12) customWidthClass = 'cschedule-width-52';
                        // if (index === 7) customWidthClass = 'cschedule-width-51';
                        // if (index === 8) customWidthClass = 'cschedule-width-50';
                        // if (index === 13) customWidthClass = 'cschedule-width-49';

                        return (
                            <div
                                key={index}
                                className={`cschedule-block ${isHalfBlock ? 'cschedule-half' : 'cschedule-full'} ${blockColor} ${customWidthClass}`}
                            >
                                <span className="cschedule-time">{item.time}</span>
                                <span className="cschedule-event">{item.title}</span>
                            </div>
                        );
                    })}

                </div>
            </div>
        </div>
    );
};

export default CongressionalSchedule;
